import React from 'react';
import { Modal, Table } from 'react-bootstrap';
import { formatDateTime, findOptionByValue, AUTOMATION_ENROLL_STATUS_CODES } from '../../utils';

// Shows exactly who is sitting at one node right now - the drill-down behind the per-card
// user count on the Automation Builder canvas. For a user signed in on more than one
// device/subscription, every known subscription for that user is listed (not just the one
// this particular enrollment is tied to), so it's clear which device actually got stuck here.
const AutomationNodeUsersModal = ({ show, nodeLabel, result, loading, page, onPageChange, onClose }) => {
    const rows = result?.data || [];
    const meta = result?.meta || {};

    return (
        <Modal show={show} onHide={onClose} size="lg" className="ns-modal automation-node-users-modal">
            <Modal.Header closeButton>
                <Modal.Title>Users at "{nodeLabel}"</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loading ? (
                    <div className="text-center">Loading...</div>
                ) : rows.length === 0 ? (
                    <div className="text-center">No user is currently at this step</div>
                ) : (
                    <Table className="table-sm" responsive>
                        <thead>
                            <tr>
                                <th>User</th>
                                <th>Status</th>
                                <th>Subscriptions / devices</th>
                                <th>Since</th>
                                <th>Resumes</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((row) => (
                                <tr key={row.id}>
                                    <td>
                                        <div>{row.userName || (row.isAnonymous ? 'Anonymous (not logged in)' : `User #${row.appUserId}`)}</div>
                                        {(row.phone || row.email) && (
                                            <small className="text-muted">{[row.phone, row.email].filter(Boolean).join(' · ')}</small>
                                        )}
                                    </td>
                                    <td>
                                        <span className={findOptionByValue(AUTOMATION_ENROLL_STATUS_CODES, row.status)?.badgeClass || 'badge rounded-pill bg-light-secondary'}>{row.statusLabel}</span>
                                        {row.lastError && <div><small className="text-danger">{row.lastError}</small></div>}
                                    </td>
                                    <td>
                                        {row.subscriptions?.length ? (
                                            row.subscriptions.map((s, i) => (
                                                <div key={s.subscriptionId || i}>
                                                    <small>
                                                        {s.name || s.deviceModel || 'Device'}
                                                        {s.deviceOs ? ` (${s.deviceOs})` : ''}
                                                        {row.subscriptionId && row.subscriptionId === s.subscriptionId ? ' — this one' : ''}
                                                    </small>
                                                </div>
                                            ))
                                        ) : (
                                            <small className="text-muted">—</small>
                                        )}
                                    </td>
                                    <td><small>{formatDateTime(row.sinceAt || row.enteredAt)}</small></td>
                                    <td>
                                        {row.status === 3 && row.nextRunAt ? (
                                            <small>{formatDateTime(row.nextRunAt)}</small>
                                        ) : (
                                            <small className="text-muted">—</small>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                )}
            </Modal.Body>
            <Modal.Footer className="justify-content-between">
                <div>
                    {meta.total ? <small className="text-muted">{meta.total} user{meta.total === 1 ? '' : 's'} total</small> : null}
                </div>
                <div className="d-flex align-items-center gap-2">
                    {meta.totalPages > 1 && (
                        <>
                            <button type="button" className="btn_theme_secondary" disabled={page <= 1} onClick={() => onPageChange(page - 1)}>Previous</button>
                            <small className="text-muted">Page {page} / {meta.totalPages}</small>
                            <button type="button" className="btn_theme_secondary" disabled={page >= meta.totalPages} onClick={() => onPageChange(page + 1)}>Next</button>
                        </>
                    )}
                    <button type="button" className="btn_theme_secondary" onClick={onClose}>Close</button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default AutomationNodeUsersModal;
